import { Component, inject, Input } from '@angular/core';
import { AnomalySeverity } from '@buda/app/types/anomaly.types';
import { NotificationsUtilService } from '@common-services/util/notifications-util.service';
import { NotificationsActions } from '@dice/app/store/notifications/notifications.actions';
import {
  ProfileNotification,
  ProfileNotificationAnomalyContent,
  ProfileNotificationType,
} from '@dice/app/types/notification.types';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { has as _has } from 'lodash';

@Component({
  selector: 'profile-notification-entry',
  templateUrl: './profile-notification-entry.component.html',
  standalone: false,
})
export class ProfileNotificationEntryComponent {
  private store = inject(Store);
  private translateService = inject(TranslateService);
  private notificationsUtilService = inject(NotificationsUtilService);

  @Input() notification: ProfileNotification;

  get title(): string {
    if (!this.notification) {
      return '';
    }
    switch (this.notification.type) {
      case ProfileNotificationType.ANOMALY:
        return 'profile.popout.anomalyTitle';
      case ProfileNotificationType.GENERAL:
      default:
        return 'profile.popout.generalNotification';
    }
  }

  get isAnomalyNotification(): boolean {
    return this.notification.type === ProfileNotificationType.ANOMALY && !!_has(this.notification, 'content.severity');
  }

  get severity(): AnomalySeverity {
    if (this.isAnomalyNotification) {
      return (this.notification.content as ProfileNotificationAnomalyContent).severity;
    }
    return null;
  }

  get businessUnit(): string {
    if (this.isAnomalyNotification) {
      const { businessUnit } = this.notification.content as ProfileNotificationAnomalyContent;
      return businessUnit;
    }
    return null;
  }

  get area(): string {
    if (this.isAnomalyNotification) {
      const { area } = this.notification.content as ProfileNotificationAnomalyContent;
      return area;
    }
    return null;
  }

  get isClickable(): boolean {
    return !!this.notification && this.notification.type === ProfileNotificationType.ANOMALY;
  }

  deleteNotification = (): void => {
    this.store.dispatch(new NotificationsActions.DeleteUserNotification(this.notification));
  };

  clickHandler = (): void => {
    this.notificationsUtilService.navigateToNotificationContent(this.notification);
  };
}
